/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
// import _map from "lodash/fp/map";
// import _filter from "lodash/fp/filter";
// import _forEach from "lodash/fp/forEach";
import moment from "moment";
import _find from "lodash/fp/find";
// import { docSet } from "../../context/doc";
// import { identityProfileUpdate } from "../../context/identity";
import { useTracked } from "../../state";
import { getShareToken } from "../../context/token";
import { loadAuthMode } from "../../context/vault";
import { identityService } from "../vault";
import { AuthMode } from "@ionic-enterprise/identity-vault";
import { getUserByIdentity, updateUser } from "../../api/user";
import { getUserIdentity } from "../../api/identity";

import { Plugins, AppState } from "@capacitor/core";
import { isPlatform, useIonLoading } from "@ionic/react";
import * as jwtDecode from "jwt-decode";

const { Storage, App } = Plugins;

interface Props {
  deviceId: any;
  pendingShare?: any;
  setPendingShare?: (pendingShare: any) => void;
  pushToken?: any;
}

const Subscriber: React.FC<Props> = ({
  deviceId,
  pendingShare,
  setPendingShare,
  pushToken,
}) => {
  const [state, dispatch] = useTracked();

  React.useEffect(() => {
    if (state.mqm) {
      const channels = [];

      if (deviceId) {
        channels.push(deviceId);
      }

      if (state.clientReferenceId) {
        channels.push(state.clientReferenceId);
      }

      if (state.identity) {
        channels.push(state.identity.toLowerCase());
      }

      if (channels.length) {
        state.mqm.pubnub.unsubscribeAll();
        state.mqm.subscribe({
          channels,
          withPresence: true,
        });

        state.mqm.pubnub.addListener({
          status: function (statusEvent: any) {
            if (statusEvent.category === "PNConnectedCategory") {
              console.log(
                "subscribed to topic",
                statusEvent.subscribedChannels
              );
            }
          },
          message: async (msg: any) => {
            onMessage(msg);
          },
        });
      } else {
        state.mqm.pubnub.unsubscribeAll();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.mqm, state.identity, state.clientReferenceId, deviceId]);

  React.useEffect(() => {
    if (state.pendingPush && state.identity && state.token) {
      const {
        header,
        message,
        identity,
        token,
        appId,
        requestId,
        requestAction,
        authRequestId,
        ui,
      } = state.pendingPush;

      if (identity.toLowerCase() === state.identity.toLowerCase()) {
        let updatedHeader = header;
        let updatedMessage = message;

        if (requestAction && requestAction.indexOf("api-key") !== -1) {
          updatedHeader = "Action Authorization";
          updatedMessage = `You have an API key ${requestAction.slice(
            8,
            requestAction.length
          )} request for ${ui}`;
        }

        setAuthorization(
          updatedHeader,
          updatedMessage,
          identity,
          token,
          appId,
          true,
          requestId,
          authRequestId
        );
      }

      dispatch({ type: "setPendingPush", pendingPush: "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.identity, state.pendingPush, state.token]);

  React.useEffect(() => {
    if (pushToken) {
      dispatch({ type: "setPushToken", pushToken });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pushToken]);

  React.useEffect(() => {
    if (state.identity && state.user && pushToken && state.token) {
      const { verifierPushToken } = state.user;

      if (verifierPushToken !== pushToken && pushToken) {
        syncPushToken(state.identity, pushToken);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.identity, state.user, pushToken, state.token]);

  React.useEffect(() => {
    if (state.identity && pendingShare) {
      const { sub, aud, keyid, iss, token } = pendingShare;
      const existing = _find(
        (val: any) => val.keyid === keyid,
        state.pendingShares
      );

      if (sub && !existing) {
        dispatch({
          type: "setPendingShare",
          pendingShare: {
            sub,
            aud,
            keyid,
            iss,
            token,
          },
        });
      }

      if (existing) {
        setNotification("Shared file was already in queue.", "info");
      }

      if (!sub) {
        setNotification("Invalid recipient", "error");
      }

      if (setPendingShare) {
        setPendingShare(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.identity, pendingShare]);

  const onMessage = (msg: any) => {
    const { userMetadata = {} } = msg;
    const { type = "" } = userMetadata;

    switch (type) {
      case "authorize": {
        authorize(msg);
        break;
      }
      case "verify": {
        setIdentityAlias(msg);
        break;
      }
      case "login": {
        setSession(msg);
        break;
      }
      case "logout": {
        clearSession(msg);
        break;
      }
      // unused feature
      // case "updateProfile": {
      //   updateProfile(msg);
      //   break;
      // }
      // unused feature
      // case "udpateTransactions": {
      //   udpateTransactions(msg);
      //   break;
      // }
      case "showPincode": {
        showPincode(msg);
        break;
      }
      // case "pushToken": {
      //   setPushToken(msg);
      //   break;
      // }
      case "pendingPush": {
        setPendingPush(msg);
        break;
      }
      case "setNotification": {
        const {
          message: { message, isError },
        } = msg;
        if (isError) {
          setNotification(message, "error");
        } else {
          setNotification(message, "success");
        }
        break;
      }
      case "account-create-verified": {
        accountCreateApproved(msg);
        break;
      }
      case "account-recover-verified": {
        accountRecoverApproved(msg);
        break;
      }
      case "updateVaultState": {
        updateVaultAuth();
        break;
      }
      default: {
        break;
      }
    }
  };

  // const setPushToken = (msg: any) => {
  //   const { message: { pushToken } } = msg;
  //   dispatch({ type: 'setPushToken', pushToken });
  // };

  const setPendingPush = (msg: any) => {
    const {
      message: { header, message, identity, token, appId, requestId },
    } = msg;
    dispatch({
      type: "setPendingPush",
      pendingPush: {
        header,
        message,
        identity,
        token,
        appId,
        requestId,
      },
    });
  };

  const accountCreateApproved = (msg: any) => {
    const {
      message: { token },
    } = msg;

    const { aud } = jwtDecode(token);

    dispatch({
      type: "setAccountCreateApproved",
      accountCreateApproved: aud,
    });
  };

  const accountRecoverApproved = (msg: any) => {
    const {
      message: { token },
    } = msg;

    const { aud } = jwtDecode(token);

    dispatch({
      type: "setAccountRecoverApproved",
      accountRecoverApproved: aud,
    });
  };

  const syncPushToken = async (identity: string, verifierPushToken: string) => {
    dispatch({ pushTokenSyncLoading: true, type: "setPushTokenSyncLoading" });

    const response: any = await updateUser(identity.toLowerCase(), {
      verifierPushToken,
    });

    if (response?.status === 200) {
      const user: any = await getUserByIdentity(identity);
      if (user?.data?.id) {
        dispatch({ user: user.data, type: "setUser" });
      }
    }

    dispatch({ type: "setPushToken", pushToken: verifierPushToken });
    dispatch({ pushTokenSyncLoading: false, type: "setPushTokenSyncLoading" });
  };

  const showPincode = async (msg: any) => {
    const {
      message: { isSetPincode },
    } = msg;
    dispatch({ type: "showApplicationsPIN", setApplicationsPin: isSetPincode });
  };

  const setSession = async (msg: any) => {
    const {
      message: { identity, token, appId },
    } = msg;
    try {
      // const w: any = await getUserIdentity(identity.toLowerCase());
      const user: any = await getUserByIdentity(identity.toLowerCase());

      if (user?.data?.id) {
        const { aliases, issuers } = user.data;

        dispatch({ user: user.data, type: "setUser" });
        dispatch({ account: user.data, type: "setAccount" });
        dispatch({ lastUser: user.data, type: "setLastUser" });

        if (appId) {
          dispatch({ appId, type: "setAppId" });
        }

        await identityService.login(
          { username: identity, token, identity },
          AuthMode.SecureStorage
        );

        await setVaultAuth();

        if (issuers) {
          dispatch({ issuers, type: "setIssuers" });
        }

        if (aliases) {
          dispatch({ aliases, type: "setAliases" });
        }

        dispatch({ identity, type: "setIdentity" });
        dispatch({ token, type: "setToken" });

        // cleanup previous failed pin attempts from locked state.
        dispatch({ type: "setPINFailedAttempts", value: 0 });

        localStorage.removeItem("isAppLocked");
      } else {
        dispatch({ type: "logout", appId: process.env.REACT_APP_APP_ID });
      }

      // if (w?.wallet && w?.wallet?.identity) {
      //   const { profile } = w.wallet;

      //   if (appId) {
      //     dispatch({ appId, type: "setAppId" });
      //   }
      //   await identityService.login(
      //     { username: identity, token, identity },
      //     AuthMode.SecureStorage
      //   );
      //   await setVaultAuth();

      //   if (profile && profile.issuers) {
      //     const issuers = JSON.parse(profile.issuers);
      //     dispatch({ issuers, type: "setIssuers" });
      //   }

      //   dispatch({ wallet: w.wallet, type: "setWallet" });
      //   dispatch({ identity, type: "setIdentity" });
      //   dispatch({ aliases: w.wallet.aliases, type: "setAliases" });
      //   dispatch({ token, type: "setToken" });
      // } else {
      //   dispatch({ type: "logout", appId: process.env.REACT_APP_APP_ID });
      // }
    } catch (e) {
      console.log(e);
      dispatch({ type: "logout", appId: process.env.REACT_APP_APP_ID });
    }
  };

  const setIdentityAlias = async (msg: any) => {
    const {
      message: { identity, token },
    } = msg;

    const user: any = await getUserByIdentity(identity);

    if (
      user?.data?.identity &&
      user?.data?.aliases &&
      user?.data?.aliases.length > 0
    ) {
      if (state.mqm) {
        await state.mqm.pubnub.publish({
          channel: identity.toLowerCase(),
          meta: {
            type: "login",
          },
          message: { identity, token, appId: process.env.REACT_APP_APP_ID },
        });
      }
    } else {
      if (!state.token) {
        dispatch({
          isCreatingAliasToken: token,
          type: "setIsCreatingAliasToken",
        });
      }
    }
  };

  const setVaultAuth = async () => {
    const { authMode, biometricType, hasSession, biometricsSupported } =
      await loadAuthMode();

    dispatch({
      type: "setVaultAuth",
      authMode,
      biometricType,
      hasSession,
      biometricsSupported,
    });
  };

  const clearSession = async (msg: any) => {
    const {
      message: { appId, isLockFromSwitchAccount },
    } = msg;
    if (
      Number(appId) === Number(process.env.REACT_APP_APP_ID) &&
      !isLockFromSwitchAccount
    ) {
      const token = localStorage.getItem("token");

      if (token) {
        if (state.showPinDialog) {
          await Storage.set({ key: "enteredPincode", value: "" });
          await Storage.set({ key: "isPincodeOpen", value: "false" });
          dispatch({ type: "hideApplicationsPIN" });

          await updateVaultAuth();
        }
        dispatch({ type: "logout", appId: process.env.REACT_APP_APP_ID });
      }
    }
  };

  const updateVaultAuth = async () => {
    const { authMode, biometricType, hasSession, biometricsSupported } =
      await loadAuthMode();

    dispatch({
      type: "setVaultAuth",
      authMode,
      biometricType,
      hasSession,
      biometricsSupported,
    });
  };

  const setNotification = (content: string, type: string) => {
    dispatch({
      notification: {
        type,
        content,
        position: "bottom-right",
        autoClose: 8000,
      },
      type: "setNotification",
    });
  };

  const setAuthorization = (
    header: string,
    message: string,
    identity: string,
    token: string,
    appId: any,
    isOpen: boolean,
    requestId: any,
    authRequestId: string
  ) => {
    dispatch({
      authorization: {
        header,
        message,
        identity,
        token,
        appId,
        isOpen,
        requestId,
        authRequestId,
      },
      type: "setAuthorization",
    });
  };

  const authorize = async (msg: any) => {
    const {
      message: {
        header,
        message,
        identity,
        token,
        appId,
        requestId,
        requestAction,
        authRequestId,
        ui,
      },
    } = msg;

    if (Number(appId) !== 1) {
      dispatch({
        type: "setPendingPush",
        pendingPush: {
          header,
          message,
          identity,
          token,
          appId,
          requestId,
          requestAction,
          authRequestId,
          ui,
        },
      });
    }
  };
  // unused code
  // const updateProfile = async (msg: any) => {
  //   try {
  //     const {
  //       message: { identity, newProfile, hasFirstTimeLogin },
  //       userMetadata: { hasSelectedProfilePic },
  //     } = msg;
  //     let updatedProfile: any = { ...newProfile };

  //     if (hasSelectedProfilePic) {
  //       const base64Img = localStorage["selectedProfileImg"];
  //       const token = await getShareToken(identity, identity);
  //       const doc = await docSet(base64Img, token);
  //       updatedProfile["profileImageStore"] = doc.store;
  //       localStorage.removeItem("selectedProfileImg");
  //     }
  //     if (!hasFirstTimeLogin) {
  //       await identityProfileUpdate(identity, {
  //         metadata: {
  //           claim: updatedProfile,
  //         },
  //       });
  //     } else {
  //       await identityProfileUpdate(identity, {
  //         metadata: {
  //           hasFirstTimeLogin,
  //         },
  //       });
  //     }

  //     if (!hasFirstTimeLogin) {
  //       setNotification(
  //         "A whole new you! Profile update successful.",
  //         "success"
  //       );
  //     }
  //   } catch (e) {
  //     setNotification(
  //       "Something went weird. We weren’t able to update your profile. Please try again.",
  //       "error"
  //     );
  //   }
  // };

  // unused code
  // const setAssetTransactions = (assetTransactions: any, type: string) => {
  //   dispatch({
  //     notification: {
  //       type,
  //       assetTransactions,
  //     },
  //     type: "setNotification",
  //   });
  // };

  // unused code
  // const udpateTransactions = async (msg: any) => {
  //   const {
  //     message: { assetId, tx, identity },
  //   } = msg;

  //   await identityProfileUpdate(identity, {
  //     metadata: {
  //       assetTransactions: {
  //         [assetId]: tx,
  //       },
  //     },
  //   });

  //   const w: any = await getUserIdentity(identity.toLowerCase());

  //   if (
  //     w &&
  //     w?.wallet &&
  //     w?.wallet?.profile &&
  //     w?.wallet?.profile?.metadata &&
  //     w?.wallet?.profile?.metadata?.assetTransactions
  //   ) {
  //     setAssetTransactions(dispatch, {
  //       ...state.assetTransactions,
  //       ...{
  //         [assetId]: tx,
  //       },
  //     });
  //   }
  // };

  return <> </>;
};

export default Subscriber;
